export default class SimpleModel<Records extends Record<string, any>> {
	constructor(protected readonly attributes: Records) {
	}

	fill(attributes: Records): void {
		Object.keys(attributes).forEach((key: keyof Records) => {
			this.setAttribute(key, attributes[key]);
		});
	}

	getAttributes(): Records {
		return this.prepareGetResult(this.attributes);
	}

	getAttribute(key: keyof Records): Records[keyof Records] {
		return this.prepareGetResult(this.attributes[key]);
	}

	setAttribute(key: keyof Records, value: Records[keyof Records]): void {
		this.attributes[key] = value;
	}

	protected prepareGetResult<T = any>(result: T): T {
		return result;
	}
}
